import React, { Component } from "react";
import ProjectDetailsModal from "./ProjectDetailsModal";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deps: {},
      detailsModalShow: false,
      activeIndex: 0,
    };
    this.carouselRef = React.createRef();
  }

  handleSlideChange = (e) => {
    this.setState({ activeIndex: e.item });
  };

  render() {
    let detailsModalShow = (data) => {
      this.setState({ detailsModalShow: true, deps: data });
    };

    let detailsModalClose = () => this.setState({ detailsModalShow: false });
    if (this.props.resumeProjects && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.projects;
      var roleText = this.props.resumeBasicInfo.role;
      var projects = this.props.resumeProjects.map(function (projects) {
        return (
          <div
            className="col-12"
            key={projects.title}
            style={{ cursor: "pointer" }}
          >
            <span className="portfolio-item d-block">
              <div className="foto" onClick={() => detailsModalShow(projects)}>
                <div>
                  <img
                    src={`${process.env.PUBLIC_URL}/${projects.images[0]}`}
                    alt="projectImages"
                    height="230"
                    style={{
                      marginBottom: 0,
                      paddingBottom: 0,
                      position: "relative",
                    }}
                  />
                  <span className="project-date">{projects.startDate}</span>
                  <br />
                  <p className="project-title-settings mt-3">
                    {projects.title}
                  </p>
                </div>
              </div>
            </span>
          </div>
        );
      });
    }
    const responsive = {
      0: { items: 1 },
      568: { items: 2 },
      1024: { items: 3 },
    };

    return (
      <section id="portfolio">
        <div className="col-md-12">
          <h1 className="section-title" style={{ color: "black" }}>
            <span>{sectionName}</span>
          </h1>
          <div className="col-md-12 mx-auto">
            <div className="row mx-auto">
              <AliceCarousel
                ref={this.carouselRef}
                mouseTracking
                items={projects}
                responsive={responsive}
                controlsStrategy="alternate"
                activeIndex={this.state.activeIndex}
                onSlideChanged={this.handleSlideChange}
                disableDotsControls={false}
                disableButtonsControls={false}
              />
            </div>
          </div>
          <ProjectDetailsModal
            show={this.state.detailsModalShow}
            onHide={detailsModalClose}
            data={this.state.deps}
            roleText={roleText}
          />
        </div>
      </section>
    );
  }
}

export default Projects;
